export default __webpack_public_path__ + "static/media/VFW_Officer.6a2f39a4.jpg";